var map = {
	"./auth.js": "./src/store/modules/auth.js",
	"./bookClass.js": "./src/store/modules/bookClass.js",
	"./character.js": "./src/store/modules/character.js",
	"./classroom.js": "./src/store/modules/classroom.js",
	"./common.js": "./src/store/modules/common.js",
	"./consultant.js": "./src/store/modules/consultant.js",
	"./modal.js": "./src/store/modules/modal.js",
	"./notification.js": "./src/store/modules/notification.js",
	"./parents.js": "./src/store/modules/parents.js",
	"./summerCamp.js": "./src/store/modules/summerCamp.js",
	"./supplementaryAgreement.js": "./src/store/modules/supplementaryAgreement.js",
	"./vipAccount.js": "./src/store/modules/vipAccount.js",
	"./vipContract.js": "./src/store/modules/vipContract.js",
	"./vipMgm.js": "./src/store/modules/vipMgm.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/store/modules sync \\.js$";